var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "roll-create-items" } }, [
    _c("div", { staticClass: "rci-header" }, [
      _c("span", {
        staticClass: "rci-header-back el-icon-arrow-left",
        on: {
          click: function ($event) {
            return _vm.$router.go(-1)
          },
        },
      }),
      _c("h1", { staticClass: "rci-header-title" }, [
        _vm._v("创建ROLL房 - 选择物品"),
      ]),
      _c("div", { staticClass: "rci-header-actions" }, [
        _c(
          "button",
          {
            staticClass: "rci-btn rci-btn--prev",
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [_vm._v("上一步")]
        ),
        _c(
          "button",
          {
            staticClass: "rci-btn rci-btn--create",
            attrs: {
              disabled: _vm.submitting || _vm.selectedItems.length === 0,
            },
            on: { click: _vm.handleCreate },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.submitting
                    ? "创建中..."
                    : "创建 (" + _vm.selectedItems.length + " 件)"
                ) +
                " "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", { staticClass: "selected-panel" }, [
      _c("div", { staticClass: "selected-panel-title" }, [
        _c("span", [_vm._v("已选物品")]),
        _c("span", { staticClass: "selected-count" }, [
          _vm._v(_vm._s(_vm.selectedItems.length) + " 件"),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "selected-panel-scroll" },
        [
          _vm.selectedItems.length === 0
            ? _c("div", { staticClass: "selected-empty" }, [
                _vm._v("暂未选择物品"),
              ])
            : _vm._l(_vm.selectedItems, function (item) {
                return _c(
                  "div",
                  {
                    key: item.mSerial,
                    staticClass: "selected-item",
                    attrs: { title: item.itemName },
                    on: {
                      click: function ($event) {
                        return _vm.removeSelected(item)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "selected-item-img",
                      attrs: { src: _vm._f("imgfilter")(item.itemPic) },
                    }),
                    _c("span", { staticClass: "selected-item-remove" }, [
                      _vm._v("×"),
                    ]),
                  ]
                )
              }),
        ],
        2
      ),
    ]),
    _c(
      "div",
      { staticClass: "inventory-section" },
      [
        _c("div", { staticClass: "ctrl-bar" }, [
          _c(
            "div",
            {
              staticClass: "select-btn",
              on: {
                click: function ($event) {
                  return _vm.selectAll(_vm.assets_list.active)
                },
              },
            },
            [
              !_vm.assets_list.active
                ? _c("i", { staticClass: "ivu-icon ivu-icon-md-checkmark" })
                : _c("i", { staticClass: "ivu-icon ivu-icon-ios-close" }),
              _vm._v(
                " " + _vm._s(_vm.assets_list.active ? "取消全选" : "全选") + " "
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "assets-list-box" }, [
          _vm.assets_list.data.list.length > 0
            ? _c(
                "ul",
                { staticClass: "assets-list" },
                _vm._l(_vm.assets_list.data.list, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      on: {
                        click: function ($event) {
                          return _vm.select(item)
                        },
                      },
                    },
                    [
                      _c("c-stockAward", {
                        attrs: {
                          rarity: item.rarity,
                          picture: item.itemPic,
                          name: item.itemName.match(/^(.*?)\s?(\(.*\))?$/)[1],
                          descriptor: _vm._f("GetItemDuration")(item.itemName),
                          price: item.price,
                          LockType: item.lockType,
                          has_picuter_rarity: "",
                          has_shadow: "",
                          has_interactive: "",
                          is_checked: item.active,
                          awardType: item.awardType,
                          present: item.present,
                          shortage: item.shortage,
                          redeeming: item.redeeming,
                          fromExchange: item.fromExchange,
                          timeExpire: item.timeExpire,
                        },
                      }),
                      item.isPin
                        ? _c("div", { staticClass: "lock-icon" }, [
                            _c("i", {
                              staticClass: "ivu-icon ivu-icon-md-lock",
                              staticStyle: {
                                color: "red",
                                "font-size": "16px",
                              },
                            }),
                          ])
                        : _vm._e(),
                      item.lockType != 0 && !item.isTransferring
                        ? _c("div", { staticClass: "lock_title" }, [
                            _vm._v("取回处理中"),
                          ])
                        : _vm._e(),
                      item.isTransferring
                        ? _c("div", { staticClass: "lock_title" }, [
                            _vm._v("赠送提取中"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              )
            : !_vm.loading
            ? _c("div", { staticClass: "none-item" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/none-item.svg"),
                    alt: "",
                  },
                }),
                _c("div", { staticStyle: { opacity: "0.3" } }, [
                  _vm._v("背包中找不到可用的饰品"),
                ]),
              ])
            : _c("div", { staticClass: "none-item" }, [
                _c("div", { staticStyle: { opacity: "0.4" } }, [
                  _vm._v("加载中..."),
                ]),
              ]),
        ]),
        _c("Page", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.assets_list.data.total > _vm.assets_list.size,
              expression: "assets_list.data.total > assets_list.size",
            },
          ],
          attrs: {
            current: _vm.assets_list.current,
            total: _vm.assets_list.data.total,
            "page-size": _vm.assets_list.size,
            "class-name": "rci-page",
          },
          on: {
            "update:current": function ($event) {
              return _vm.$set(_vm.assets_list, "current", $event)
            },
            "on-change": _vm.pageAvailableData,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }